export default __webpack_public_path__ + "static/media/googleplay.477aa906.svg";